module.exports = __webpack_public_path__ + "assets/img/triple_open.89f1455c.svg";